exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".selected_button[data-v-96d79d0c] {\n  border: 2px solid black;\n  border-radius: 5px;\n}\n.btn-purple[data-v-96d79d0c] {\n  background: #6e7ff2;\n}\n.btn-light-red[data-v-96d79d0c] {\n  background: #f87676;\n}\n.card-header[data-v-96d79d0c] {\n  background-color: rgba(0, 0, 0, .03);\n}\n.w-85[data-v-96d79d0c] {\n  width: 85%;\n}\n.w-70[data-v-96d79d0c] {\n  width: 70%;\n}\n.w-15[data-v-96d79d0c] {\n  width: 15%;\n}\n.text-align-end[data-v-96d79d0c] {\n  text-align: end;\n}\n", ""]);

// exports
